<template>
  <div class="thanks">
    <img src="../assets/thanksImage.png" />
  </div>
</template>
<script>
export default {
  name: "Thanks",
  data() {
    return {};
  },
  components: {},
  methods: {},
  created() {
    setTimeout(() => this.$router.push({ path: "/" }), 3000);
  },
};
</script>

<style></style>
